// olap-client/src/components/chat/BottomNav.jsx
import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { Context } from '../..';

const BottomNav = observer(() => {
  const { chat } = useContext(Context);

  const tabs = [
    { id: 'chats', icon: '💬', label: 'Чаты' },
    { id: 'contacts', icon: '👥', label: 'Контакты' },
    { id: 'settings', icon: '⚙️', label: 'Настройки' },
    { id: 'profile', icon: '👤', label: 'Профиль' }
  ];

  return (
    <div style={{
      display: 'flex',
      borderTop: '1px solid #e4e4e5',
      background: '#ffffff',
      paddingBottom: 'env(safe-area-inset-bottom)'  // Для iPhone с вырезом
    }}>
      {tabs.map(tab => {
        const isActive = chat.mobileTab === tab.id;
        return (
          <div
            key={tab.id}
            onClick={() => chat.setMobileTab(tab.id)}
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '8px 0',
              cursor: 'pointer',
              color: isActive ? '#3390ec' : '#707579',
              transition: 'color 0.2s'
            }}
          >
            <span style={{ fontSize: '24px', marginBottom: '2px' }}>
              {tab.icon}
            </span>
            <span style={{ 
              fontSize: '11px',
              fontWeight: isActive ? 'bold' : 'normal'
            }}>
              {tab.label}
            </span>
          </div>
        );
      })}
    </div>
  );
});

export default BottomNav;